<template>
    <section>
        <div class="ss-breadcrumb">
            <div class="container-hts">
                <ul class="margin-0 p-0">
                    <li><router-link to="/soan-tai-lieu">Soạn tài liệu</router-link></li>
                    <li><router-link to="/soan-tai-lieu">Bài giảng điện tử</router-link></li>
                    <li><router-link to="">{{ nameLecture }}</router-link></li>
                </ul>
            </div>
        </div>
        <div class="container">
            <div class="name-leson mt-3">
                <h4 v-if="!isEditNameLesson">
                    <strong>{{ dataElectronicLecture.name }}</strong>
                    <img @click="handleEditNameLesson" class="icon-edit" src="@/assets/img/edit.png"
                        v-if="Number(isEdit) == 1" />
                </h4>
                <div v-else class="display-flex">
                    <div class="row">
                        <div class="col-md-6">
                            <b-form-input id="numberLesson" v-model="nameLesson" type="text"
                                placeholder="Nhập tên bài giảng" autocomplete="off" class="form-control" />
                        </div>
                        <div class="col-md-6">
                            <a href="javascript:;" class="primary-color-txt font-size-17 btn-cancel"
                                @click="handleCancelEditNameLesson">Hủy</a>
                            <a href="javascript:;" class="btn btn-agree font-size-17 btn-delete"
                                @click="handleUpdateName()">Đồng ý</a>
                        </div>
                    </div>
                </div>
            </div>
            <b-tabs pills>
                <b-tab @click="handleOnChangeTab(tabInfo)" title="Thông tin" :active="tabActive == tabInfo">
                    <TabInfoElectronicLecture :type="ELECTRONIC_LECTURE_WAREHOUSE"
                        @getDetailLessonClassSchool="getDetailLessonClassSchool"
                        :dataElectronicLecture="dataElectronicLecture"
                        v-if="tabActive == tabInfo && dataElectronicLecture.name" :isEdit="Number(isEdit)" />
                </b-tab>
                <b-tab @click="handleOnChangeTab(tabContent)" title="Nội dung" :active="tabActive == tabContent">
                    <TabContentElectronicLecture :type="ELECTRONIC_LECTURE_WAREHOUSE"
                        :dataElectronicLecture="dataElectronicLecture"
                        v-if="tabActive == tabContent && dataElectronicLecture.name" :isEdit="Number(isEdit)" />
                </b-tab>
                <b-tab @click="handleOnChangeTab(tabDocument)" title="Tài liệu đính kèm"
                    :active="tabActive == tabDocument">
                    <TabAttachment :type="ELECTRONIC_LECTURE_WAREHOUSE" :dataElectronicLecture="dataElectronicLecture"
                        v-if="tabActive == tabDocument && dataElectronicLecture.name" :isEdit="Number(isEdit)" />
                </b-tab>
            </b-tabs>
        </div>
    </section>
</template>
<script>
import TabInfoElectronicLecture from './_components/TabInfoElectronicLecture'
import TabContentElectronicLecture from './_components/TabContentElectronicLecture'
import { getAuth } from "@/utils/jwt";
import { ROLE_TEACHER, ROLE_PUPIL } from "@/store/auth/constants";
import { getDetail, saveLessonClassSchool } from './../../_api/LessonClassSchoolServices'
import TabAttachment from './_components/TabAttachment'
import { PLANING_LESSON_WAREHOUSE, ELECTRONIC_LECTURE_WAREHOUSE } from './../../constants/constants_enum'
export default {
    components: {
        TabInfoElectronicLecture,
        TabContentElectronicLecture,
        TabAttachment
    },
    data() {
        return {
            isEditNameLesson: false,
            PLANING_LESSON_WAREHOUSE, ELECTRONIC_LECTURE_WAREHOUSE,
            tabActive: 2,
            tabInfo: 1,
            tabContent: 2,
            tabDocument: 3,
            nameLesson: '',
            dataElectronicLecture: {
                id: 0,
                name: '',
                bookTypeId: '',
                classId: '',
                subjectId: '',
                numberLesson: '',
                description: '',
                isPublic: false,
                type: 2
            },
            authInfo: getAuth(),
            roleTeacher: ROLE_TEACHER,
            roleHocSinh: ROLE_PUPIL,
            nameLecture: '',
            isEdit: 0,
        }

    },
    mounted() {
        this.nameLecture = this.$router.history.current.query.name
        if (this.authInfo.roleCode == this.roleHocSinh) {
            this.$router.push('/danh-sach-lop-hoc')
        }

        this.dataElectronicLecture.id = this.$route.query.id
        if (this.dataElectronicLecture.id > 0) {
            this.getDetailLessonClassSchool()
        }
        this.isEdit = this.$route.query.isEdit
    },
    methods: {
        handleUpdateName() {
            this.dataElectronicLecture.name = this.nameLesson
            let self = this
            saveLessonClassSchool(this.dataElectronicLecture).then(res => {
                if (res && res.data && !res.errors) {
                    self.$toast.success('Cập nhật thông tin thành công')
                    self.handleCancelEditNameLesson()
                }
            })
        },
        handleCancelEditNameLesson() {
            this.isEditNameLesson = false
        },
        handleEditNameLesson() {
            this.nameLesson = this.dataElectronicLecture.name
            this.isEditNameLesson = true
        },
        getDetailLessonClassSchool() {

            let self = this
            getDetail(this.dataElectronicLecture.id).then(res => {
                if (res && res.data && !res.errors) {
                    self.dataElectronicLecture = {
                        id: res.data.id,
                        name: res.data.name,
                        bookTypeId: res.data.bookTypeId,
                        classId: res.data.classId,
                        subjectId: res.data.subjectId,
                        numberLesson: res.data.numberLesson,
                        description: res.data.description,
                        isPublic: res.data.isPublic,
                        type: res.data.type,
                    }
                }
            })
        },
        handleOnChangeTab(tab) {
            this.tabActive = tab
        }
    }
}
</script>
<style lang="scss" scoped>
.icon-edit {
    width: 15px;
    cursor: pointer;
}

.btn-agree {
    margin-left: 10px;
    background: #0f3dba;
    color: white;
    line-height: 19px;
}

.margin-top-10 {
    margin-top: 20px;
}
</style>